import { useCallback, useState, type ReactNode } from 'react';

export function useToast() {
  const [message, setMessage] = useState<string | null>(null);

  const showToast = useCallback((msg: string) => {
    setMessage(msg);
    window.setTimeout(() => {
      setMessage(null);
    }, 2200);
  }, []);

  let toast: ReactNode = null;
  if (message) {
    toast = (
      <div className="fixed bottom-10 left-1/2 z-[120] -translate-x-1/2">
        <div className="flex items-center gap-2 rounded-full bg-foreground-950/90 px-5 py-2.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-checkbox-circle-fill text-accent-400" />
          <span>{message}</span>
        </div>
      </div>
    );
  }

  return { toast, showToast };
}